import { useState } from "react";
import { twMerge } from "@/lib/twMerge";

/** A vendor/app logo (from Trelica). Decorative — the name is always shown beside it,
 * so `alt` is empty. With no `src`, or if the image fails to load, renders the name's
 * initial in a tile when `fallback` is set, and nothing otherwise. */
export function Logo({
  src,
  name,
  className,
  fallback = false,
}: {
  src: string | null | undefined;
  name: string;
  className?: string;
  fallback?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    if (!fallback) return null;
    return (
      <div
        aria-hidden="true"
        className={twMerge("grid shrink-0 place-items-center rounded bg-sunken font-medium text-text/60", className)}
      >
        {name.slice(0, 1).toUpperCase()}
      </div>
    );
  }
  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      className={twMerge("shrink-0 rounded object-contain", className)}
    />
  );
}
